import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./pages/login";
import Dashboard from "./pages/dashboard";
import Customers from "./pages/customers";
import CustomerDetail from "./pages/customers/[id]";
import Settings from "./pages/settings";
import PersonalLoanApplications from "./pages/personalLoans";
import PersonalLoanDetail from "./pages/personalLoans/[id]";
import BusinessLoanApplications from "./pages/businessLoans";
import BusinessLoanDetail from "./pages/businessLoans/[id]";
import DocumentVerification from "./pages/documentVerification";
import { useState, useEffect } from "react";
import { auth } from "./firebase";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => setUser(u || null));
    return () => unsub();
  }, []);

  // while we don't know auth state yet, don't render anything
  if (user === undefined) return null;

  if (!user) return <Navigate to="/login" replace />;

  return children;
}

function App() {
  return (
    <>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers"
        element={
          <ProtectedRoute>
            <Customers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers/:id"
        element={
          <ProtectedRoute>
            <CustomerDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/personal-loans"
        element={
          <ProtectedRoute>
            <PersonalLoanApplications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/personal-loans/:id"
        element={
          <ProtectedRoute>
            <PersonalLoanDetail />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/loans/:id"
        element={
          <ProtectedRoute>
            <PersonalLoanDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business-loans"
        element={
          <ProtectedRoute>
            <BusinessLoanApplications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/business-loans/:id"
        element={
          <ProtectedRoute>
            <BusinessLoanDetail /> 
          </ProtectedRoute>
        }       
      />
      <Route
        path="/document-verification"
        element={
          <ProtectedRoute>
            <DocumentVerification />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default App;
